<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      {
        icon: 'mdi-home-outline',
        title: 'Anasayfa',
        to: '#hero'
      },
      {
        icon: 'mdi-information-outline',
        title: 'Özellikler',
        to: '#features'
      },
      {
        icon: 'mdi-download-box-outline',
        title: 'Detaylar',
        to: '#about'
      },
      {
        icon: 'mdi-currency-usd',
        title: 'Üyelik Paketleri',
        to: '#pricing'
      }
    ]
  }),
  props: {
    color: String,
    flat: Boolean
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850
    },
		goToTarget(target) {
			if(this.isHome) {
				this.$vuetify.goTo(target)
			} else {
				this.$router.push('/')
				.then(() => this.$vuetify.goTo(target))
			}
		}
  },
  computed: {
    logo() {
      return this.siteData?.logo || require('@/assets/img/bgDrawer.jpg')
    },
    isHome() {
      return this.$route.name === 'Home'
    }
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false
        }
      }
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
	}
}
</script>

<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      light
			:color="color"
    >
      <v-list class="pa-0">
        <v-list-item>
            <v-img :src="logo" contain alt="Logo" width="100%" max-height="56px" />
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
          v-for="({icon, title, to}, i) in items"
          :key="i"
          link
          @click="goToTarget(to)"
        >
					<v-list-item-title class="subtitile-1">{{ title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
			app
			:color="color"
			:dark="flat"
			:light="!flat"
			class="app-bar"
		>
      <v-container :fluid="isMiniPc || $vuetify.breakpoint.xsOnly" class="d-flex align-center pa-0">
        <v-toolbar-title>
          <router-link :to="{ name: 'Home' }">
            <v-img :src="logo" contain max-height="56px" max-width="200px" />
          </router-link>
        </v-toolbar-title>
        <v-spacer />
        <template>
          <v-app-bar-nav-icon
            @click.stop="drawer = !drawer"
            class="mr-4"
            v-if="isXs"
          />
          <div v-else>
            <v-btn v-for="(item, index) in items" :key="`nav-${index}`" text @click="goToTarget(item.to)">
              <span class="mr-2">{{ item.title }}</span>
            </v-btn>
            <v-btn class="ml-2" outlined rounded text :href="appUrl">
              <span>Giriş Yap</span>
            </v-btn>
            <v-btn class="ml-2" shaped color="success" :href="`${appUrl}/#/auth/register`">
              <span>Kayıt Ol</span>
            </v-btn>
          </div>
        </template>
      </v-container>
    </v-app-bar>
  </div>
</template>

<style scoped>
/*.v-toolbar {*/
/*  transition: 0.6s;*/
/*}*/

/*.expand {*/
/*  height: 80px !important;*/
/*  padding-top: 10px;*/
/*}*/

/*.app-bar {*/
/*  z-index: 99;*/
/*}*/
</style>


